import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';

/**
 * Modal de confirmación reutilizable
 */
function ConfirmModal({
  isOpen,
  toggle,
  title = 'Confirmar acción',
  message = '¿Está seguro de realizar esta acción?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  confirmColor = 'danger',
  loading = false,
}) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-black">
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          {cancelText}
        </Button>
        <Button color={confirmColor} onClick={handleConfirm} disabled={loading}>
          {loading ? 'Procesando...' : confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmModal;

